import React from 'react';
import './History.css'; // Make sure to import the CSS file

const history = () => {
  return (
    <div className="about-container">
      <div className="content">
        <h1>PACE GROUP</h1>
        <div className="yellow-line1"></div>
        <p>
          PACE group is an umbrella group headed by Dr. P.A. Ibrahim Haji as the Chairman. We manage a number of reputed educational institutions in India and abroad. We are dedicated to promoting an effective learning environment that encourages excellence and diversity in thoughts and endeavor.
        </p>
        <p>
          PACE Group currently manages 11 educational institutions with over 4,000 teaching staff, 500 non-teaching staff, and over 36,000 students from 85 nationalities. PACE Group proposes to have many more modern educational institutions in view of the high demand from parents and the respect and reputation our institutions have gained over the years.
        </p>
        <p>
          The management also plans to establish its educational innovation wing with its own resource center where action research will be conducted to solve the day-to-day problems related to teaching and learning processes and to equip the teachers with the latest techniques in the field of education and ultimately empower teachers to make teaching more learner-oriented and lively. The center would endeavor to have qualitative improvements in the existing institutions, wherever they are, and start new educational institutions with the latest infrastructure by using modern techniques in education.
        </p>
      </div>
      <div className="ed">
        <img src="/images/pace.png" alt="PACE Group" />
      </div>
    </div>
  );
};

export default history;
